import {useQueryClient} from '@tanstack/react-query';
import {useCallback, useEffect} from 'react';
import useTypedDispatch from '../../../../common/useTypedDispatch';
import {contentFactory} from '../../../../factory/contentFactory';
import {SortOption} from '../../../../graphql/generated/types';
import {useContentHomeProductListQuery} from '../../../../wrapper/contentWrapper';
import {clearProductEdgeListMap} from '../state/contentHomeSlice';

export function useProductListWindowedQuery({
  seriesId,
  boughtOnly,
  sortOption,
}: {
  seriesId: number;
  boughtOnly?: boolean;
  sortOption?: SortOption;
}) {
  const queryClient = useQueryClient();
  const dispatch = useTypedDispatch();

  const fetchProductListWindowedQuery = useCallback(
    async ({startCursor}: {startCursor: string}) => {
      const data = await queryClient.fetchQuery(
        contentFactory.contentHomeProductList(
          {
            seriesId,
            boughtOnly,
            sortType: sortOption?.param,
            after: startCursor,
          },
          {
            gcTime: Infinity,
            staleTime: Infinity,
          }
        )
      );
      return data.contentHomeProductList?.edges;
    },
    [boughtOnly, queryClient, seriesId, sortOption?.param]
  );
  const inValidateWindowQuery = useCallback(() => {
    const queryKey = useContentHomeProductListQuery.getKey({
      seriesId,
      boughtOnly,
      sortType: sortOption?.param,
    });
    queryClient.invalidateQueries({queryKey});
  }, [boughtOnly, queryClient, seriesId, sortOption?.param]);

  useEffect(() => {
    return () => {
      dispatch(
        clearProductEdgeListMap({
          seriesId,
        })
      );
      inValidateWindowQuery();
    };
  }, [dispatch, inValidateWindowQuery, seriesId]);

  return {
    fetchProductListWindowedQuery,
    inValidateWindowQuery,
  };
}
